// extracted by mini-css-extract-plugin
module.exports = {"loader":"ringLoder_loader__sqS_S","svg":"ringLoder_svg__cu_Ik","rotate":"ringLoder_rotate__1jjGP","dash":"ringLoder_dash__VU90l"};